import React, { useState, useMemo, useCallback } from 'react';

import { subDays, format } from 'date-fns';

import { Report } from '~/components';
import { DateTime, RadioGroup } from '~/components/Form';
import { PesquisaTabela } from '~/components/Form/v2';
import { t } from '~/helpers';

export default function RelHistoricoCadDVEC() {
  const [open, setOpen] = useState(true);
  const [enterprise, setEnterprise] = useState('');
  const [vehicle, setVehicle] = useState('');
  const [user, setUser] = useState('');

  const dateTime = useMemo(
    () => ({
      start: format(subDays(new Date(), 7), 'dd/MM/yyyy 00:00:00'),
      end: format(new Date(), 'dd/MM/yyyy 23:59:59'),
    }),
    []
  );

  const exports = useMemo(
    () => [
      { label: 'PDF', value: 'pdf' },
      { label: 'Excel', value: 'excel' },
    ],
    []
  );

  const company = useMemo(
    () => [
      {
        id: 'idempresaveiculo',
        label: t('s.cadastro.empresaveiculo.idempresaveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeempresaveiculo',
        label: t('s.cadastro.empresaveiculo.nomeempresaveiculo'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const vehicles = useMemo(
    () => [
      {
        id: 'idveiculo',
        label: t('s.configuracao.comboio.idveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'placaveiculo',
        label: t('s.cadastro.veiculo.placaveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'nomemodeloveiculo',
        label: t('s.menu.cadastro.veiculo.modelo'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const users = useMemo(
    () => [
      {
        id: 'codigousuario',
        label: t('s.cadastro.usuario.codigousuario'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeusuario',
        label: t('s.cadastro.usuario.nomeusuario'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const handleSerializeFormData = useCallback(
    (data) => ({
      ...data,
      nomeempresaveiculo: data.idempresaveiculo ? enterprise : '',
      nomemodeloveiculo: data.idveiculo ? vehicle : '',
      nomeusuario: data.codigousuario ? user : '',
    }),
    [enterprise, vehicle, user]
  );

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.menu.relatorio.relhistoricocaddvec')}
      relatorio="relhistoricocaddvec"
      serialize={handleSerializeFormData}
      initials={{
        datahorainicial: dateTime.start,
        datahorafinal: dateTime.end,
        formato: 'pdf',
      }}
    >
      <DateTime
        time
        name="datahorainicial"
        label={t('s.geral.opcoes.datahorainicial')}
      />

      <DateTime
        time
        name="datahorafinal"
        label={t('s.geral.opcoes.datahorafinal')}
      />

      <PesquisaTabela
        name="idempresaveiculo"
        label={t('s.operacao.abastecimento.idempresaveiculo')}
        primary="idempresaveiculo"
        secondary="nomeempresaveiculo"
        url="empresasveiculos"
        header={company}
        getValue={(value) => setEnterprise(value.nomeempresaveiculo || '')}
      />

      <PesquisaTabela
        name="idveiculo"
        label={t('s.geral.camposistema.idveiculo')}
        primary="idveiculo"
        secondary="nomemodeloveiculo"
        url="veiculos"
        header={vehicles}
        getValue={(value) => setVehicle(value.nomemodeloveiculo || '')}
      />

      <PesquisaTabela
        name="codigousuario"
        label={t('s.menu.cadastro.usuario')}
        primary="codigousuario"
        secondary="nomeusuario"
        url="usuarios"
        header={users}
        getValue={(value) => setUser(value.nomeusuario || '')}
      />

      <RadioGroup
        row
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={exports}
        serialize={(value) => value}
      />
    </Report>
  );
}
